import {CasinoLegacyDeepLinkActionBase} from '../casino-legacy-deep-link-action-base';
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../../common/const/casinofied-analytics-consts";
import {AppIdentifiers, AreaType, CashierSessionType, TriggerType} from "@sparkware/uc-sdk-core";
import {IFullCashierSpecificParams} from "@sparkware/uc-sdk-core/lib/apps/full-cashier/full-cashier.interfaces";


export class CashierDeepLinkAction extends CasinoLegacyDeepLinkActionBase {

  async execute(): Promise<void> {
    const businessCorrelationId = this.services.tools.getGuid();
    await this.services.messageBroker.channels.performAction.topics.openCashier.execute({
      correlationID: businessCorrelationId,
      launchInfo: {
        businessCorrelationID: businessCorrelationId,
        trigger: TriggerType.automaticFlow,
        sourceAppVersion: this.services.sdk.getSkin().getVersion(),
        channel: {
          source: CHANNEL_SOURCE.casinoClient,
          area: AreaType.externalClick,
          element: CHANNEL_ELEMENTS.deepLink
        },
        sourceAppID: AppIdentifiers.CasinoClient,
        appSpecificParameters: {
          sessionType: CashierSessionType.FullCashier,
          ...this.getCashierSpecificParameters()
        }
      }
    });

    await this._executeNextAction();
  }

  public getCashierSpecificParameters(): Partial<IFullCashierSpecificParams> {
    const options: Partial<IFullCashierSpecificParams> = {
      sessionType: CashierSessionType.FullCashier
    };

    let params = this.descriptor.actionParams && this.descriptor.actionParams.id;
    if(params) {
      let cashierParams = params.toString().split(',');
      if(cashierParams.length  > 0) {
        options.sessionType = cashierParams[0].trim();
        if(cashierParams.length > 1) {
          options.promoCode = cashierParams[1].trim();
        }
      }
    }

    if(this.descriptor.promoCode) {
      options.promoCode = this.descriptor.promoCode;
    }

    return options;
  }
}
